import MicroCustomAccordion from "../MicroCustomAccordion/MicroCustomAccordion";
import {
  Product,
  SKUAdjustmentAccordionDetails,
  ViewMicroScenarioDto,
} from "orval/generated/models";
import { ProductColumnData } from "../../../types";
import RenderAccordions from "../RenderAccordions/RenderAccordions";
import { ProductConfigurationsMicro } from "../../MicroAdjustmentsTable/types";

export type AdjustmentAccordionProps = {
  productColumnData: ProductColumnData[] | undefined;
  products: Product[] | undefined;
  accordion: SKUAdjustmentAccordionDetails;
  scenario: ViewMicroScenarioDto | undefined;
  dataStructureKey: ProductConfigurationsMicro;
};

function MicroAdjustmentAccordion({
  products,
  productColumnData,
  accordion,
  scenario,
  dataStructureKey,
}: AdjustmentAccordionProps) {
  const accordionDetails =
    products &&
    RenderAccordions(
      accordion,
      productColumnData,
      products,
      scenario,
      dataStructureKey as ProductConfigurationsMicro,
      accordion.accordion ===
        ProductConfigurationsMicro.OTHER_PACKAGING_EMISSION_FACTORS,
    );

  return (
    <MicroCustomAccordion
      title={accordion.accordion}
      hasSubAccordions={Boolean(
        accordion.sub_accordions && accordion.sub_accordions.length,
      )}
      details={accordionDetails}
      scenario={scenario}
    />
  );
}

export default MicroAdjustmentAccordion;
